import React from "react";
import { useCreateAdHocExpenseRateMutation } from "./queries.generated";
import { MutationForm } from "~/components/forms/MutationForm";
import { CreateExpenseRateFormData, CreateExpenseRateFormProps } from "./types";
import { parseNum } from ".";
import { ValidationResponse } from "~/gql/types";

export const NewAdHocExpenseRate: React.FC<CreateExpenseRateFormProps> = (
  props
) => {
  const { setLoading, onSuccess, initialValues, rateSheetName, children } =
    props;

  const [rawAdHocMutation] = useCreateAdHocExpenseRateMutation();

  const handleSubmit = async (values: CreateExpenseRateFormData) => {
    const variables = {
      name: values?.name!,
      invoiceLabel: values?.invoiceLabel || null,
      expenseAccount: values?.expenseAccount || null,
      glAccount: values?.glAccount || null,
      rateSheetName: rateSheetName,
      rate: parseNum(values?.rate),
    };

    const result = await rawAdHocMutation({ variables });

    return result?.data?.expenseRates?.addAdHocRate as ValidationResponse;
  };

  return (
    <MutationForm
      setLoading={setLoading}
      initialValues={initialValues}
      runMutation={handleSubmit}
      onSuccess={onSuccess}
      allowPristineSubmit
    >
      {children}
    </MutationForm>
  );
};
